import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { GetWithAuth } from '../utils/api';

const MyOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [, setError] = useState('');
  const { token, isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated() && token) {
      fetchOrders();
    } else {
      setLoading(false);
      setError('Debes iniciar sesión para ver tus pedidos');
    }
  }, [token, isAuthenticated]);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      setError('');
      const data = await GetWithAuth('/orders/my-orders');
      if (data.success) {
        setOrders(data.orders || []);
      } else {
        setError(data.message || 'Error al cargar pedidos');
      }
    } catch (error) {
      console.error('Error fetching orders:', error);
      setError('Error al cargar pedidos. Por favor, intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="container" style={{ padding: '4rem 1rem', textAlign: 'center' }}>Cargando pedidos...</div>;
  }

  if (orders.length === 0) {
    return (
      <div className="container" style={{ padding: '4rem 1rem', textAlign: 'center' }}>
        <h2>No tienes pedidos todavía</h2>
        <Link to="/products" style={{ color: '#667eea', fontSize: '1.1rem' }}>Ver Productos</Link>
      </div>
    );
  }

  const getStatusBadge = (status) => {
    const statusConfig = {
      pending: { label: 'Pendiente', color: '#f59e0b' },
      processing: { label: 'Procesando', color: '#8b5cf6' },
      shipped: { label: 'Enviado', color: '#10b981' },
      delivered: { label: 'Entregado', color: '#059669' },
      cancelled: { label: 'Cancelado', color: '#ef4444' }
    };

    const config = statusConfig[status] || { label: status, color: '#666' };
    return <span style={{ padding: '0.25rem 0.75rem', background: config.color, color: 'white', borderRadius: '12px', fontSize: '0.85rem' }}>{config.label}</span>;
  };

  return (
    <div className="container" style={{ padding: '2rem 1rem', minHeight: '70vh' }}>
      <h1 style={{ marginBottom: '2rem' }}>Mis Pedidos</h1>

      {orders.map((order) => (
        <div key={order.id} style={{ background: 'white', padding: '1.5rem', borderRadius: '12px', marginBottom: '1.5rem', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
            <div>
              <h3 style={{ margin: 0 }}>Pedido #{order.orderNumber}</h3>
              <p style={{ color: '#666', margin: '0.25rem 0', fontSize: '0.9rem' }}>{new Date(order.createdAt).toLocaleDateString()}</p>
            </div>
            <div style={{ textAlign: 'right' }}>
              {getStatusBadge(order.orderStatus)}
              <p style={{ fontWeight: 'bold', margin: '0.5rem 0 0', fontSize: '1.1rem' }}>${order.total.toFixed(2)}</p>
            </div>
          </div>

          <div style={{ borderTop: '1px solid #e5e7eb', paddingTop: '1rem', marginTop: '1rem' }}>
            <p style={{ fontSize: '0.9rem', color: '#666', marginBottom: '0.5rem' }}>{order.items.length} producto(s)</p>
            <Link to={`/order/${order.id}`} style={{ color: '#667eea', textDecoration: 'none', fontWeight: '500' }}>Ver detalles →</Link>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MyOrders;
